import { Button, InputIcon, InputText } from "@sellar-io/components";
import { useState } from "react";
import { useNavigate } from "react-router";
import * as ROUTES from "../../../constants/routes";
import {
  SellarContextActionEnum,
  useSellarContext,
  useSellarUser,
} from "../../../hooks";
import { InputContainer } from "@sellar-io/components";
import { Icon } from "../../index";
import { useMenuDrawerContext } from "../MenuDrawerContextProvider.shared";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../modal/Dialog";
import { BusinessSwitcherContent } from "./BusinessSwitcherContent";

export const BusinessSwitcherDialog = () => {
  const { user } = useSellarUser();
  const [searchValue, setSearchValue] = useState("");
  const [{ businessSwitcherActive }, dispatch] = useSellarContext();
  const { isMobileDisplayType, setIsOnScreen } = useMenuDrawerContext();
  const navigate = useNavigate();

  const setActive = (isActive: boolean) => {
    if (!isActive && isMobileDisplayType) {
      setIsOnScreen(false);
    }

    return dispatch({
      type: SellarContextActionEnum.CHANGE_BUSINESS_SWITCHER_ACTIVE,
      businessSwitcherActive: isActive,
    });
  };

  return (
    <Dialog
      active={businessSwitcherActive}
      onDismiss={() => setActive(false)}
      fullHeight={true}
    >
      <DialogNavigation
        title={"Switch business account"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => setActive(false)}
      >
        <InputContainer>
          <InputIcon icon={"MAGNIFY"} />
          <InputText
            required={false}
            placeholder={"Search..."}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </InputContainer>
      </DialogNavigation>
      <DialogContent>
        <BusinessSwitcherContent
          searchValue={searchValue}
          onClick={(businessId) => {
            dispatch({
              type: SellarContextActionEnum.CHANGE_SELECTED_BUSINESS_ID,
              selectedBusinessId: businessId,
            });
            setActive(false);
          }}
        />
      </DialogContent>
      <DialogCTA className={"sticky bottom-0 bg-white"}>
        <Button
          onClick={() => {
            setActive(false);
            navigate(ROUTES.NEW_VENUE);
          }}
        >
          <Icon icon={"PLUS"} />
          Add Venue
        </Button>
        {user && user.type == "admin" && (
          <Button
            onClick={() => {
              setActive(false);
              navigate(ROUTES.NEW_SUPPLIER);
            }}
          >
            <Icon icon={"PLUS"} />
            Add Supplier
          </Button>
        )}
      </DialogCTA>
    </Dialog>
  );
};
